export default __webpack_public_path__ + "img/8e6cda4fe9f6bae902da340b843d9773.svg";